export default __webpack_public_path__ + "static/sheet-c6a42163a3684a96da1df9c87aaf21b2.png";